import { render } from "./RoleTabsView.vue?vue&type=template&id=588319d7&scoped=true&ts=true"
import script from "./RoleTabsView.vue?vue&type=script&lang=ts"
export * from "./RoleTabsView.vue?vue&type=script&lang=ts"

import "./RoleTabsView.vue?vue&type=style&index=0&id=588319d7&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588319d7"]])

export default __exports__